export enum PreauthTokenErrorEnum {
    PreAuthTokenInvalid = '232',
    PreAuthTokenExpired = '233',
    PreAuthTokenAlreadyUsed = '234'
}
